export const ACTION = {
  BOARD_STRUCTURE: "board-structure",
  STRUCTURE_AND_DATA: "structure-and-data",
  SHARE_COLUMNS: "share-columns",
  SHARE_ENTIRE_BOARD: "share-entire-board",
  SAVE_AS_REPORT: "save-as-report",
};
